import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Download, Filter } from '../../../../Svg';
import CatPagination from '../../../../Website/utils/Pagination';
import AllOrderTable from './AllOrderTable';
import { getAllPoOrderThunk, getCartOrdersThunk, setPoOrderPage, setPoorderTab } from '../../../../Website/redux/poorderSlice';
import { useDispatch, useSelector } from 'react-redux';
import { exportDataExcel, formateDate } from '../../../../Website/utils/utils';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '13px',
  color: '#475569',
  backgroundColor: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  height: '36px',
  fontWeight: '600',
  padding: '0 14px',
  fontFamily: 'inherit',
  '&:hover': {
    backgroundColor: '#f8fafc',
    borderColor: '#cbd5e1',
  },
}));

const statuss = ['NEW', 'PROCESSING', 'SHIPPED', 'DELIVERED', 'CANCELED'];

const AllOrderTab = () => {
  const tabs = ['Cart order', 'PO orders'];
  const dispatch = useDispatch();
  const { orders, page, loading, activeTab, refresh } = useSelector(state => state.poorder);
  const [limit, setLimit] = useState(25);
  const [exportLoading, setExportLoading] = useState(false);
  const data = orders?.data;
  const totalPages = orders?.totalPages;
  const totalItems = orders?.totalItems;
  const itemsPerPage = orders?.limit;
  const [status, setStatus] = useState('');

  const start = (page - 1) * limit + 1;
  const end = totalPages === page ? totalItems : (page - 1) * limit + limit;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (statusVal) => {
    if (statusVal !== undefined && typeof statusVal === 'string') {
      setStatus(statusVal);
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    if (activeTab === "Cart order") {
      dispatch(getCartOrdersThunk(`?page=${page}&limit=${limit}&status=${status}`));
    } else {
      dispatch(getAllPoOrderThunk(`?page=${page}&limit=${limit}&status=${status}`));
    }
  }, [refresh, activeTab, page, limit, status, dispatch]);

  const exportbomenq = async () => {
    setExportLoading(true);
    const exportOrderData = data;
    const exportdata = exportOrderData?.map((item) => ({
      'id': item?._id || '-',
      'createBy': item?.userId?.fullName || '-',
      'products': (item?.products?.length || 0) + ' products',
      'Status': item?.status || '-',
      'CreatedAt': formateDate(item?.createdAt),
    }));
    setExportLoading(false);
    exportDataExcel(exportdata, "AllOrders");
  };

  const handleTabChange = (tab) => {
    dispatch(setPoorderTab(tab));
    dispatch(setPoOrderPage(1));
    setStatus('');
  };

  return (
    <Paper sx={{ width: '100%', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', overflow: 'hidden', border: '1px solid #f1f5f9' }}>
      {/* Header Bar */}
      <Box sx={{ padding: '24px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafafa', borderBottom: '1px solid #f1f5f9', flexWrap: 'wrap', gap: '16px' }}>
        <Box>
          <Typography sx={{ fontSize: "20px", color: '#0f172a', fontWeight: '700', fontFamily: 'inherit' }}>
            All Orders
          </Typography>
          <Typography sx={{ fontSize: "13px", color: '#64748b', marginTop: '2px' }}>
            View and track your cart orders and purchase orders (PO).
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <div>
            <ActionButton onClick={handleClick}>
              <Filter /> <span style={{ marginLeft: '6px' }}>{status ? status : "Filters"}</span>
            </ActionButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => handleClose()}
              PaperProps={{
                elevation: 3,
                sx: { borderRadius: '8px', marginTop: '4px' }
              }}
            >
              <MenuItem onClick={() => handleClose('')} sx={{ fontSize: '13px', color: '#64748b' }}>All Statuses</MenuItem>
              {statuss.map((i) => (
                <MenuItem key={i} onClick={() => handleClose(i)} sx={{ fontSize: '13px', color: '#0f172a', fontWeight: '500' }}>
                  {i}
                </MenuItem>
              ))}
            </Menu>
          </div>

          <Button
            onClick={exportbomenq}
            disabled={exportLoading}
            variant="contained"
            size="small"
            sx={{
              background: '#512DA8',
              color: '#ffffff',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '13px',
              fontWeight: '600',
              padding: '6px 16px',
              height: '36px',
              boxShadow: 'none',
              '&:hover': {
                background: '#4527a0',
                boxShadow: '0 4px 12px rgba(81, 45, 168, 0.2)'
              }
            }}
          >
            <Download /> <span style={{ marginLeft: '6px' }}>{exportLoading ? "Please wait..." : "Download"}</span>
          </Button>
        </Box>
      </Box>

      {/* Tabs */}
      <Box sx={{ display: 'flex', gap: '10px', padding: '16px 30px', borderBottom: '1px solid #f1f5f9', background: '#ffffff' }}>
        {tabs.map((tab) => (
          <Button
            key={tab}
            onClick={() => handleTabChange(tab)}
            sx={{
              textTransform: 'none',
              borderRadius: '20px',
              padding: '6px 20px',
              fontSize: '13px',
              fontWeight: '600',
              background: activeTab === tab ? '#512DA8' : '#f1f5f9',
              color: activeTab === tab ? '#ffffff' : '#64748b',
              '&:hover': {
                background: activeTab === tab ? '#4527a0' : '#e2e8f0',
              }
            }}
          >
            {tab}
          </Button>
        ))}
      </Box>

      {/* Body Content */}
      <Box sx={{ padding: '24px 30px' }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '60px 0' }}>
            <img src="/assets/__Iphone-spinner-1.gif" alt="loading" style={{ width: 35, height: 35 }} />
          </Box>
        ) : (
          <>
            {data?.length > 0 ? (
              <AllOrderTable
                data={data}
                activeTab={activeTab}
                loading={loading}
              />
            ) : (
              <Box sx={{ padding: '60px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  </svg>
                </div>
                <Typography sx={{ fontSize: '15px', color: '#0f172a', fontWeight: '600' }}>
                  No Orders Found
                </Typography>
                <Typography sx={{ fontSize: '13px', color: '#64748b', textAlign: 'center' }}>
                  There are no {activeTab} records to display at this time.
                </Typography>
              </Box>
            )}
          </>
        )}

        {(!loading && data?.length > 0) && (
          <Box sx={{ marginTop: '20px' }}>
            <CatPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              start={start}
              end={end}
              page={page}
              setPage={setPoOrderPage}
            />
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default AllOrderTab;
